import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { InvoiceDocument } from './InvoiceView';

const STATUS_LABELS = { awaiting_advance: 'Awaiting Advance', partially_paid: 'Partially Paid', fully_paid: 'Fully Paid', overdue: 'Overdue' };
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PublicInvoice() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [reasons, setReasons] = useState([]);
  useEffect(() => {
    axios.get(`${BACKEND}/api/public/invoice/${id}`).then(r => setD(r.data)).catch(()=>setD({error:true}));
    axios.get(`${BACKEND}/api/reason-codes`).catch(() => ({ data: [] })).then(r => setReasons(r?.data || []));
  }, [id]);
  if (!d) return <div className="p-6 text-sm text-[var(--muted)]">Loading…</div>;
  if (d.error) return <div className="p-8 text-center serif text-[24px]">Invoice not found</div>;
  return (
    <div className="min-h-screen py-6 px-4" style={{background:'var(--cream-alt)'}}>
      <div className="max-w-3xl mx-auto">
        <InvoiceDocument inv={d.invoice} settings={d.settings} reasons={reasons} statusLabels={STATUS_LABELS}/>
      </div>
    </div>
  );
}
